import cn from 'classnames'
import { bool, element, func, number, shape, string } from 'prop-types'
import React from 'react'
import { RiExternalLinkLine } from 'react-icons/ri'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import st from './ProductSummary.module.css'

const ProductSummary = ({
  bottomString,
  className,
  imageAlt,
  productURL,
  imageSrc,
  mod,
  name,
  id,
  size,
  isOrder,
  details,
  vendorCode,
  slug,
  isDiscontinued,
  intl
}) => {
  const imageJSX = <img alt={imageAlt} src={imageSrc} />
  const imageStyle = {
    height: size,
    width: size
  }

  // Determine artemest domain based on current hostname
  const isStaging =
    typeof window !== 'undefined' &&
    window.location.hostname === 'vendor-staging.artemest.net'
  const artemestDomain = isStaging
    ? 'https://artemeststaging.co'
    : 'https://artemest.com'

  return (
    <div
      className={cn(st.wrap, {
        [className]: className.length > 0,
        [st.mod1]: mod === 1
      })}
    >
      <span className={st.image} style={imageStyle}>
        <a target="_blank" href={imageSrc} rel="noreferrer">
          {imageJSX}
        </a>
      </span>
      <div className={st.cnt}>
        {productURL ? (
          <Link target="_blank" to={productURL}>
            <p className={st.name}>{name}</p>
          </Link>
        ) : (
          <p className={st.name}>{name}</p>
        )}
        <p className={st.id}>SKU: {id}</p>
        {vendorCode && (
          <p className={st.id}>
            {intl.formatMessage({ id: 'Vendor code' })}: {vendorCode}
          </p>
        )}
        {slug && !isDiscontinued && (
          <a
            href={`${artemestDomain}/products/${slug}`}
            target="_blank"
            rel="noopener noreferrer"
            className={st.externalLink}
          >
            <RiExternalLinkLine />
            <FormattedMessage id="View product page on site" />
          </a>
        )}
        {bottomString.length > 0 && (
          <p className={st.bottomString}>{bottomString}</p>
        )}
        {isOrder && details}
      </div>
    </div>
  )
}

ProductSummary.defaultProps = {
  bottomString: '',
  className: '',
  imageAlt: '',
  productURL: '',
  imageSrc: '',
  mod: 0,
  name: '',
  id: '',
  size: 48,
  isOrder: false,
  details: null,
  vendorCode: '',
  slug: '',
  isDiscontinued: false
}
ProductSummary.propTypes = {
  intl: shape({
    formatMessage: func
  }),
  bottomString: string,
  className: string,
  imageAlt: string,
  productURL: string,
  imageSrc: string,
  mod: number,
  name: string,
  id: string,
  size: number,
  category: string,
  isOrder: bool,
  details: element,
  vendorCode: string,
  slug: string,
  isDiscontinued: bool
}

export default injectIntl(ProductSummary)
